import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR

const TimerProduct = ({ dateToday, dateInit, dateEnd }) => {
    if (!dateEnd || dateInit > dateToday) return '';
    const dif = dateEnd - dateToday;
    const [timer, setTimer] = useState((dif > 0) ? dif : 0);
    const [hour, setHour] = useState('0');
    const [min, setMin] = useState('0');
    const [sec, setSec] = useState('0');
    const [day , setDay] = useState('0');
    const [progress , setProgress] = useState(0);
    let timeout = null;

    useEffect(() => {
        
        timeout = setTimeout(() => updateTimer(), 1000);

        return function cleanup() {
            clearTimeout(timeout);
        };
    });

    const updateTimer = () => {
        if (timer <= 0) return false;

        let secTotal = timer / 1000;
        let seconds = Math.floor(secTotal % 60);

        let minTotal  = secTotal / 60;
        let minuts = Math.floor( minTotal % 60 );

        let hourTotal  = minTotal / 60;
        let hours = Math.floor( hourTotal % 24 );

        let days = Math.floor( hourTotal / 24 );

        setDay((days.toString().length < 2) ? '0' + days.toString() : days);
        setHour((hours.toString().length < 2) ? '0'+ hours.toString() : hours);
        setMin((minuts.toString().length < 2) ? '0'+ minuts.toString() : minuts);
        setSec((seconds.toString().length < 2) ? '0' + seconds.toString() : seconds);

        if(dateEnd >= dateInit && (timer <= (dateEnd - dateInit))){
            setProgress(100 - (timer / (dateEnd - dateInit)) * 100);
        }

        setTimer(timer - 1000);
    };

    if (timer <= 0) return '';
    
    return (
        <div className="principal-container-timer-offers">
            <div className="container-progress-bar">
                <progress max="100" value={progress}></progress>
            </div>

            <div className="container-time-watch">
                {(day !== '00') && <div className="wrapper-timer-offers-days">
                    <span className="timer-offers-days">{day}</span>
                    <span className="timer-offers-days-title">Días</span>
                </div>}

                {(day !== '00') && <div className="timer-offers-two-points">:</div>}

                <div className="wrapper-timer-offers-hours">
                    <span className="timer-offers-hours">{hour}</span>
                    <span className="timer-offers-hours-title">Hrs</span>
                </div>

                <div className="timer-offers-two-points">:</div>

                <div className="wrapper-timer-offers-minuts">
                    <span className="timer-offers-minuts">{min}</span>
                    <span className="timer-offers-minuts-title">Min</span>
                </div>

                <div className="timer-offers-two-points">:</div>

                <div className="wrapper-timer-offers-seconds">
                    <span className="timer-offers-seconds">{sec}</span>
                    <span className="timer-offers-seconds-title">Seg</span>
                </div>
            </div>
        </div>
    )
};


TimerProduct.propTypes = {
    dateToday: PropTypes.number,
    dateInit: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    dateEnd: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default TimerProduct;
